import React from "react";
import PropTypes from "prop-types";

import { Box, Button, Link, Typography } from "@material-ui/core";
import GetAppOutlinedIcon from "@material-ui/icons/GetAppOutlined";

const ImageBox = ({ target, label, t }) => {
  return (
    <Box mb={1} ml={1}>
      {" "}
      <Link underline="none" href={target} target="_blank" rel="noopener">
        <Button
          variant="contained"
          startIcon={<GetAppOutlinedIcon fontSize="small" />}
        >
          JPG
        </Button>
      </Link>
      {" "} ({t('image')}: {label}) 
    </Box>
  );
};

export default function ImageDl(props) {
  const canvas = props["canvases"];

  //Image Download
  return (
    <Box>
      {canvas.map((canvas, index) => (
        <ImageBox
          key={index}
          target={canvas.getCanonicalImageUri()}
          label={props.canvasLabel(canvas.id)}
          t={props.t}
        />
      ))}
    </Box>
  );
}

ImageBox.propTypes = {
  target: PropTypes.string,
  label: PropTypes.string,
};

ImageDl.propTypes = {
  t: PropTypes.func,
  canvas: PropTypes.object,
};